module.exports = __webpack_public_path__ + "static/media/1_A1_24.6b6aba61.png";